"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _List = _interopRequireDefault(require("../List"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
var styles = {
  "group-name": "CustomResults__group-name__3VFc0",
  "groupName": "CustomResults__group-name__3VFc0"
}; 
require('./CustomResults.css');
var CustomResults = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var matches = props.matches,
    onKeyDown = props.onKeyDown;
  var groupedCustomResults = _react.default.useMemo(function () {
    return matches.reduce(function (accum, current) {
      var existingGroup = accum.find(function (item) {
        return item.groupName === current.groupName;
      });
      if (existingGroup) {
        existingGroup.results.push(current);
        return accum;
      }
      return [].concat((0, _toConsumableArray2.default)(accum), [{
        groupName: current.groupName,
        results: [current]
      }]);
    }, []);
  }, [matches]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    _react.default.createElement(_List.default, {
      onKeyDown: onKeyDown,
      ref: ref,
      testId: "custom"
    }, groupedCustomResults.map(function (group, index) {
      // special case for "summary" like results (one item with same group name)
      if (group.results.length === 1 && group.groupName === group.results[0].label) {
        return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
          isSection: true,
          title: group.results[0].title,
          path: group.results[0].path,
          key: index
        }, group.results[0].label);
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, group.groupName ? /*#__PURE__*/_react.default.createElement("li", {
        className: styles.groupName
      }, group.groupName) : null, group.results.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
          title: item.title,
          path: item.path,
          key: item.path
        }, item.label);
      }));
    }))
  );
});
var _default = exports.default = CustomResults;
//# sourceMappingURL=CustomResults.js.map